<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardTicketUpdateRecordList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    store-select-label="办理门店"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
    quick-time-tab-label="修改时间"
  >
    <v-column-time value="修改时间"/>
    <el-table-column label="办理门店" width="150" align="center" prop="store_name"/>
    <v-column-avatar
      label="操作者"
      avatar-key="administrator_avatar"
      nickname-key="administrator_nickname"
    />
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="课次券类型" width="150" align="center" prop="card_ticket_type_name"/>
    <el-table-column label="失效日期" width="300" align="center">
      <template v-slot="{ row }">
        <div class="flex-justify-center">
          <el-tag type="info">{{ row.old_expire_time | timeToYmd('-') }}</el-tag>

          <div v-if="row.old_expire_time !== row.expire_time">
            <v-icon name="arrow-right"/>

            <el-tag>{{ row.expire_time | timeToYmd('-') }}</el-tag>
          </div>
        </div>
      </template>
    </el-table-column>
    <el-table-column label="剩余次数（次）" width="200" align="center">
      <template v-slot="{ row }">
        <div class="flex-justify-center" v-if="row.old_expire_number || row.expire_number">
          <el-tag type="info">{{ row.old_expire_number | toYuan }}</el-tag>

          <div v-if="row.old_expire_number !== row.expire_number">
            <v-icon name="arrow-right"/>

            <el-tag>{{ row.expire_number | toYuan }}</el-tag>
          </div>
        </div>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column label="修改原因" align="center">
      <template v-slot="{ row }">{{ row.reason }}</template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-update-record-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>课次券类型</span>
              <span>{{ v.card_ticket_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>失效日期</span>
              <span>{{ v.old_expire_time | timeToYmd }} → {{ v.expire_time | timeToYmd }}</span>
            </div>
            <div class="list-item-detail">
              <span>剩余次数</span>
              <span>{{ v.expire_number | toYuan }} 次</span>
            </div>
            <div class="list-item-detail">
              <span>办理门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>修改原因</span>
              <span>{{ v.reason }}</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/card-ticket-update-record';
import { getLegalQueryList } from '@/utils/formats';
import { checkYmdIsBetweenSetUpAndToday } from '@/utils/validate';

export default {
  name: RouteConfig.cardTicketUpdateRecordList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      store_id: '',
      start_date: '',
      end_date: '',
      limit: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isLoading: false,
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'defaultStoreId',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
  },
};
</script>
